import { useState, useEffect } from "react";
import reqAuth from "../loaders/reqAuth";

const useAuth = () => {
  const [isAuth, setIsAuth] = useState(false);
  useEffect(() => {
    const checkAuth = async () => {
      try {
        await reqAuth();
        setIsAuth(true);
      } catch (err) {
        setIsAuth(false);
      }
    };
    if (!sessionStorage.getItem("token")) return setIsAuth(false);
    checkAuth();
  }, [typeof sessionStorage != "undefined" ? sessionStorage : null]);
  return [isAuth, setIsAuth];
};
export default useAuth;
